
<script>
  import { viewActive } from 'apps/imd/stores';
  import action from '~/action';

  import CircleButton from 'components/CircleButton.svelte';
  import * as OpeningHoursView from 'components/hours/OpeningHoursView.svelte';
  import * as SearchView from 'components/search/SearchView.svelte';
  import * as ThirdPartyView from 'components/ThirdPartyView.svelte';

  let view;
  let viewInstance;
  let viewNav;
  let viewNavInstance;

  $: {
    switch ($viewActive) {
    case 'hours':
      ({ default: view, viewNav } = OpeningHoursView);
      break;
    case 'search':
    case 'searchresults':
      ({ default: view, viewNav } = SearchView);
      break;
    case 'thirdparty':
      ({ default: view, viewNav } = ThirdPartyView);
      break;
    default:
      view = viewNav = null;
    }
  }

  function handleNavBack () {

    if (!viewInstance) {
      return action.goBack();
    }

    /**
     *  Current view can handle back navigation by exporting function with same
     *  name. If component method return true it will prevent default action.
     */
    const preventDefault = viewInstance.handleNavBack && viewInstance.handleNavBack();
    if (!preventDefault) {
      action.goBack();
    }

    /**
     *  Current view can react navication back to it.
     */
    if (viewInstance.navBackToview) {
      viewInstance.navBackToview();
    }
  }

</script>

<nav class="view__head">
  <div class="navigation-back">
    <CircleButton icon="ic_home" on:click="{() => action.goTo('start')}" title="Home"/>
    <CircleButton icon="ic_back" active={true} on:click="{handleNavBack}" title="Back" />
  </div>
  <svelte:component this={viewNav} bind:this={viewNavInstance} />
</nav>

<svelte:component this={view} {viewNavInstance} bind:this={viewInstance} />

<style>
  .view__head {
    display: flex;
    position: relative;
    height: 136px;
    padding-top: 32px;
    align-items: center;
    z-index: 10;
  }

  .navigation-back {
    display: flex;
    width: 20%;
    justify-content: center;
    align-items: center;
  }

  .navigation-back :global(.circle-btn) {
    margin: 0 -6px;
  }
</style>
